// root state object.
// each Vuex instance is just a single state tree.
const state = {
    lang: 'fr',
    client: 'demo',
    userIdBO: null,
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
    /**
     * Change the current language
     *
     * @function   changeLanguage
     *
     * @param      {Object} state
     * @param      {string} lang
     */
    changeLanguage (state, lang) {
        state.lang = lang;
    },
    /**
     * Change the client
     *
     * @function   changeLanguage
     *
     * @param      {Object} state
     * @param      {string} client
     */
    setClient (state, client) {
        state.client = client;
    },
    /**
     * Change the userIdBO
     *
     * @function   setUserIdBO
     *
     * @param      {Object} state
     * @param      {string} userIdBO
     */
    setUserIdBO (state, userIdBO) {
      state.userIdBO = userIdBO;
    }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
    changeLanguage: ({ state, commit }, lang) => commit('changeLanguage', lang),
    setClient: ({ state, commit }, client) => commit('setClient', client),
    setUserIdBO: ({ state, commit }, userIdBO) => commit('setUserIdBO', userIdBO)
};

// getters are functions
const getters = {
    /**
     * Get current language
     */
    getCurrentLang:  state => state.lang,

    /**
     * Get current language
     */
    getCurrentClient:  state => state.client,
    /**
     * Get current language
     */
    getUserIdBO:  state => state.userIdBO,
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/general-config.js